enum IncentiveCampaignRoutes {
  List = '/content-settings/incentive-campaign',
  Add = '/content-settings/incentive-campaign/add',
  Edit = '/content-settings/incentive-campaign/:id',
}

export default IncentiveCampaignRoutes
